export class Range {
    public start: number; // [0,1]
    public end: number; // [0,1] && >=start

    public get length(): number {
        return this.end - this.start;
    }
}
